import React from "react";
import "./NuestrosServiciosSection.css";
import NavigationButton from "../Button/NavigationButton";

export default function NuestrosServiciosSection() {
    const BUTTON_TITTLE = "Saber más";
    const BUTTON_PATH = "#ContactSection";

    return (
        <section className="nuestros-servicios" id="NuestrosServiciosSection">
            <p className="nuestros-servicios-titulo">Nuestros servicios</p>
            <div className="image-grid">
                <div className="grid-item item-1">
                    <p className="titulo-servicio">{"Organización Inicial de Bodas y Eventos"}</p>
                    <hr className="linea-verde" />
                    <p className="description-servicio">{"Para quienes necesitan una guía para comenzar a planificar."}</p>
                    <div className="boton-container">
                        <NavigationButton titulo={BUTTON_TITTLE} path={BUTTON_PATH}/>
                    </div>
                </div>
                <div className="grid-item item-2">
                    <p className="titulo-servicio">{"Coordinación Integral de la Planificación"}</p>
                    <hr className="linea-verde"/>
                    <p className="description-servicio">{"Nos encargamos de los detalles para que disfrutes del proceso de organización de la boda."}</p>
                    <div className="boton-container">
                        <NavigationButton titulo={BUTTON_TITTLE} path={BUTTON_PATH}/>
                    </div>
                </div>
                <div className="grid-item item-3">
                    <p className="titulo-servicio">{"Dirección y Ejecución del dia de la boda"}</p>
                    <hr className="linea-verde"/>
                    <p className="description-servicio">{"Nos aseguramos de que todo fluya perfectamente el gran día acompañándolos un mes previo a la boda."}</p>
                    <div className="boton-container">
                        <NavigationButton titulo={BUTTON_TITTLE} path={BUTTON_PATH}/>
                    </div>
                </div>
                <div className="grid-item item-4">
                    <p className="titulo-servicio">{"Experiencia Premium"}</p>
                    <p className="titulo-servicio">{"'Llave en mano'"}</p>
                    <hr className="linea-verde"/>
                    <p className="description-servicio">{"Para quienes buscan una boda o evento completamente personalizado y sin preocupaciones."}</p>
                    <div className="boton-container">
                        <NavigationButton titulo={BUTTON_TITTLE} path={BUTTON_PATH}/>
                    </div>
                </div>
            </div>
        </section>
    );
}
